<template>
  <div v-resize="calculateLedtPaddingPosition">
    <div class="primarybar hvh-flex">
      <div class="tab" :class="{ active: activeSheetGroup === groupName, disabled: isGroupDisabled(groupName) }" v-for="groupName in Object.keys(workbookSheets)" :key="groupName">
        <router-link :to="workbookSheets[groupName][0].url">{{ groupName }}</router-link>
      </div>
    </div>
    <div class="secondarybar hvh-flex space-between">
      <div class="hvh-flex" :style="{ 'padding-left': `${leftPadding}px` }">
        <template v-if="workbookSheets[activeSheetGroup].length > 1">
          <div class="tab mr-2 ml-1" :class="{ active: isActiveUrl(item), disabled: !item.url }" v-for="(item, index) in workbookSheets[activeSheetGroup]" :key="index" @click="$router.push(item.url)">
            <router-link :to="item.url">{{ item.text }}</router-link>
          </div>
        </template>
      </div>
      <div class="buttons hvh-flex">
        <v-btn :loading="undoLoader" :disabled="undoLoader" small flat class="ma-2" @click="$emit('undo')">
          <v-icon left small>mdi-undo</v-icon>
          Undo
        </v-btn>
        <v-btn :loading="resetFiltersLoader" :disabled="resetFiltersLoader" flat small class="ma-2" @click="$emit('reset-filters')">
          <v-icon left small>mdi-filter-remove</v-icon>
          Reset Filters
        </v-btn>
        <v-btn v-if="!hideBackToTop" v-scroll="onScroll" v-show="showBackToTop" small flat class="ma-2" :style="{ right: 0, bottom: `${showBackToTopBtnBottom}px` }" fixed right @click="$emit('toTop')">
          <v-icon left small>mdi-arrow-up-bold</v-icon>Back to top
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['undoLoader', 'resetFiltersLoader', 'workbookSheets', 'activeSheet', 'hideBackToTop'],
  data() {
    return {
      leftPadding: 0,
      showBackToTop: false,
      showBackToTopBtnBottom: 0,
    };
  },
  computed: {
    activeSheetGroup() {
      return Object.keys(this.workbookSheets)
        .find(key => this.workbookSheets[key].find(this.isActiveUrl)) || Object.keys(this.workbookSheets).first();
    },
  },
  methods: {
    isActiveUrl(sheet) {
      return this.$router.matcher.match(sheet.url).params.sheet === this.activeSheet;
    },
    calculateLedtPaddingPosition() {
      var el = document.querySelector('.primarybar .active');
      if (el && this.leftPadding !== el.offsetLeft) {
        this.leftPadding = el.offsetLeft;
      }
    },
    isGroupDisabled(groupName) {
      return !this.workbookSheets[groupName].any(f => f.url);
    },
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.showBackToTop = top > 20

      let documentHeight = document.body.scrollHeight;
      let currentScroll = window.scrollY + window.innerHeight;
      // When the user is [modifier]px from the bottom, fire the event.
      let modifier = 30;
      if (currentScroll + modifier > documentHeight) {
        this.showBackToTopBtnBottom = (((currentScroll + modifier) - documentHeight) + 8);
      }
      else { this.showBackToTopBtnBottom = 0; }
    },
  },
  updated() {
    this.calculateLedtPaddingPosition();
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisTableauHorizontalMenu'] = this;
    this.calculateLedtPaddingPosition();
    setTimeout(this.calculateLedtPaddingPosition, 100);
  },
}
</script>


<style lang="scss" scoped>
.primarybar {
  background-color: rgb(116, 143, 148);
  color: white;

  @media (min-width: 1100px) {
    padding-left: 200px;
  }

  .tab {
    opacity: 0.7;
    a {
      display: block;
      color: white;
      white-space: nowrap;
      padding: 10px 12px;
      border-left: 2px solid #596f7e;
      font-weight: 600;
    }
    &.active {
      opacity: 1;
      background: rgb(66, 96, 104);
    }
  }
}

.secondarybar {
  background-color: white;
  overflow-x: auto;
  .tab {
    margin: 6px 0;
    border-radius: 5px;
    a {
      display: block;
      color: #002f6c;
      white-space: nowrap;

      font-size: 13px;
      line-height: 13px;
      font-weight: 700;
      padding: 10px 8px 8px 8px;
    }
    &:not(.active) {
      &:hover {
        background-color: #e5e5e5;
      }
    }
    &.active {
      background-color: rgb(204 227 231);

      &:hover {
        background-color: rgb(147 164 167);
      }
    }
  }
  .buttons {
    background-color: white;
  }
}
</style>